/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import "../../styles/ComponentsStyles/Universal/DropDownInput.style.css";

const DropDownInput = ({
  type = "text",
  label,
  name,
  placeholder,
  suggestionList = [],
  value,
  errors,
  touched,
  setTouched,
  setFieldValue,
  multiple = false,
  style,
}) => {
  const containerRef = useRef(null);
  const [inputValue, setInputValue] = useState(() =>
    multiple ? (Array.isArray(value) ? value : []) : value || ""
  );
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [blurInput, setBlurInput] = useState(false);

  useEffect(() => {
    setFieldValue && setFieldValue(inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (!multiple) return;

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [multiple]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    if (!multiple) {
      setInputValue(val);
      const filtered = suggestionList.filter((item) =>
        item.toLowerCase().includes(val.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowDropdown(true);
    }
  };

  const handleSelect = (selected) => {
    if (!multiple) {
      setInputValue(selected);
      setShowDropdown(false);
    }
  };

  const handleMultipleChange = (e) => {
    const { value: item, checked } = e.target;
    if (!Array.isArray(inputValue)) return;

    const updated = checked
      ? [...inputValue, item]
      : inputValue.filter((v) => v !== item);
    setInputValue(updated);
  };

  const handleBlur = (e) => {
    if (!multiple) {
      const val = e.target.value;
      if (val === "") {
        e.target.setAttribute("style", "border:2px solid var(--grayColor)");
        setFieldValue("");
        if (errors) {
          e.target.setAttribute("style", "border:2px solid red");
        }
        setBlurInput(true);
      } else if (!suggestionList.includes(val)) {
        setBlurInput(false);
        e.target.setAttribute(
          "style",
          "border:2px solid var(--redColor); background:#ff000029"
        );
      } else {
        setBlurInput(false);
      }
    }
  };
  useEffect(() => {
    if (multiple) {
      setInputValue(Array.isArray(value) ? value : []);
    } else {
      setInputValue(value || "");
    }
  }, [value, multiple]);

  return (
    <div ref={containerRef} className="dropDownInputContaier" style={style}>
      <label htmlFor={name} className="t-12 poppins">
        {label}
      </label>

      <div className="suggestionInputContainer">
        {!multiple ? (
          <input
            autoComplete="off"
            type="text"
            name={name}
            className={`dropDownInput ${
              type.toLowerCase() === "color" ? "dropDownInputColorSelector" : ""
            }`}
            placeholder={placeholder}
            value={inputValue}
            style={{
              border:
                errors && errors[name] && touched && touched[name]
                  ? "2px solid red"
                  : undefined,
            }}
            onChange={handleInputChange}
            onFocus={(e) => {
              setShowDropdown(true);
              setFilteredSuggestions(suggestionList);
              setTouched && setTouched(name, true);
              setBlurInput(false);
              e.target.style.border = "2px solid var(--greenColor)";
            }}
            onBlur={(e) => {
              const input = e.target;
              setTimeout(() => {
                setShowDropdown(false);
                if (!input) return;
                handleBlur({ target: input });
              }, 150);
            }}
            required
          />
        ) : (
          //multiple input container
          <div
            className="dropDownInput"
            tabIndex={0}
            value={value}
            onFocus={(e) => {
              setShowDropdown(true);
              setTouched && setTouched(name, true);
              e.currentTarget.style.border = "2px solid var(--greenColor)";
              e.currentTarget.style.backgroundColor = "var(--greenBack)";
            }}
            onBlur={(e) => {
              const current = e.currentTarget;
              setTimeout(() => {
                setBlurInput(true);
                if (!current) return;

                if (inputValue.length === 0) {
                  current.style.backgroundColor = "transparent";

                  if (errors && errors[name]) {
                    current.style.border = "2px solid red";
                  }
                } else {
                  current.style.backgroundColor = "var(--greenBack)";
                }
              }, 150);
            }}
            style={{
              padding: "0.5rem",
              cursor: "pointer",
              border:
                inputValue.length === 0 &&
                touched &&
                touched[name] &&
                errors &&
                errors[name]
                  ? "2px solid red"
                  : inputValue.length === 0
                  ? "2px solid var(--grayBorder)"
                  : "2px solid var(--greenColor)",
              borderRadius: "6px",
              minHeight: "2.2rem",
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              alignItems: "center",
              outline: "none",
              background:
                typeof inputValue && inputValue.length > 0
                  ? "var(--greenBack) !important"
                  : "transparent !important",
            }}
          >
            {inputValue.length > 0 ? (
              inputValue.map((item, idx) => (
                <span
                  key={idx}
                  style={{
                    background: "var(--greenColor)",
                    color: "#fff",
                    borderRadius: "4px",
                    padding: "2px 6px",
                    fontSize: "12px",
                    fontFamily: "Poppins-Regular",
                  }}
                >
                  {item}
                </span>
              ))
            ) : (
              <span
                style={{
                  color: "var(--grayColor)",
                  fontSize: "13px",
                  fontFamily: "Poppins-Regular",
                  opacity: 0.8,
                }}
              >
                {placeholder || "Select options..."}
              </span>
            )}
          </div>
        )}
      </div>

      {errors &&
        errors[name] &&
        touched &&
        touched[name] &&
        blurInput === true && (
          <ErrorMessage
            name={name}
            component="div"
            className="textInputError"
          />
        )}

      {showDropdown && (
        <div className="suggestionContainer">
          <ul
            className={
              multiple
                ? "multiOptList flex-col h-fit radius-6"
                : "suggestioHintContainer"
            }
          >
            {(multiple ? suggestionList : filteredSuggestions).map(
              (item, index) =>
                multiple ? (
                  <li key={index}>
                    <input
                      type="checkbox"
                      value={item}
                      checked={inputValue.includes(item)}
                      onChange={handleMultipleChange}
                      className="multiOptselectorInputTag"
                    />
                    <span
                      style={{
                        color: inputValue.includes(item)
                          ? "var(--greenColor)"
                          : "var(--textColor)",
                      }}
                    >
                      {item}
                    </span>
                  </li>
                ) : (
                  <li
                    key={index}
                    className="dropdown-item"
                    onMouseDown={() => handleSelect(item)}
                    style={{
                      color:
                        item === inputValue
                          ? "var(--greenColor)"
                          : "var(--textColor)",
                    }}
                  >
                    {item}
                  </li>
                )
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

DropDownInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  suggestionList: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.any,
  errors: PropTypes.object,
  touched: PropTypes.object,
  setTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  multiple: PropTypes.bool,
  style: PropTypes.object,
};

export default DropDownInput;
